/*
 * The default and the component name only: the names list and what reads it are in
 * `page-icon-search.ts`, so a screen that draws an icon does not carry every name (T-0559's entry
 * budget — a module is bundled whole, and this one sits in the web entry).
 */

/**
 * A page's icon is a Lucide name in kebab case (`rocket`, `panels-top-left`): the name both
 * `lucide-react` and `lucide-react-native` render, so no surface needs a mapping of its own.
 * A page stores `null` for "not chosen", which draws this one.
 */
export const DEFAULT_PAGE_ICON = 'panels-top-left';

export const PAGE_ICON_NAME_MAX_LENGTH = 64;

/** `arrow-down-0-1` → `ArrowDown01`, the export name in `lucide-react`. */
export function pageIconComponentName(name: string): string {
  return name
    .split('-')
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join('');
}
